var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.1300048828125 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "inset-shadow"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceAlpha",
    result: "inset-selection"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 1 1 1 1 1"
  })), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic",
    result: "original-no-fill"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "0 0 1"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "original-no-fill",
    result: "new-source-alpha",
    values: "                       0 0 0 0 0                       0 0 0 0 0                       0 0 0 0 0                       0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "new-source-alpha",
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "new-source-alpha",
    result: "blur2",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "new-source-alpha",
    result: "blur3",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "blur"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur3"
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "inset-selection",
    in2: "blur",
    result: "inset-blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "over",
    in: "original-no-fill",
    in2: "inset-blur"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M68.14 39.78l2.11-1.22 2.8-1.62v-3.96l-2.2-1.27-5.79 3.36-21.33 12.36-22.77-13.19-4.52-2.62-2.36 1.36v3.96l2.8 1.62 24.18 14.03V82.6l2.5 1.44 2.5-1.44V52.58l22.08-12.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#184473",
    d: "M16.88 38.56l-2.8-1.62v30.08L41.06 82.6V52.59L16.88 38.56z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#184473",
    d: "M9.12 34.07l-2.28-1.32-.01.01L0 28.79V76.3L41.06 100V88.33L9.12 69.89V34.07z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#03b6f0",
    d: "M75.8 28.84l2.47-1.44 6.45-3.73L43.73 0 2.72 23.69l8.75 5.07 32.09-18.53L75.8 28.84z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#03b6f0",
    d: "M20.96 34.24l22.77 13.19 21.33-12.36 5.79-3.36-27.29-15.75-27.12 15.66 4.52 2.62z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0582d2",
    d: "M70.25 38.56l-2.11 1.22-22.08 12.8V82.6l26.99-15.58V36.94l-2.8 1.62z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0582d2",
    d: "M80.29 32.76l-.01-.01-2.27 1.32v35.82L46.06 88.33V100l41.07-23.71v-47.5l-6.84 3.97z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo_only.fcda18585844fee3c7e0f5987e675bd2.svg";
export { ForwardRef as ReactComponent };